import { render, staticRenderFns } from "./AddDynamicStatus.vue?vue&type=template&id=20eaecfb&"
import script from "./AddDynamicStatus.vue?vue&type=script&lang=js&"
export * from "./AddDynamicStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports